import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import './Trivia.css';
import triviaVideo from '../assets/trivia/trivia.MOV';

const Trivia = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <div className="trivia-page">
      <div className="trivia-container">
        <div className="trivia-content">
          <h1 className="trivia-title">Tuesday Night Trivia</h1>
          <div className="trivia-time">Every Tuesday at 7 PM</div>
          
          <div className="trivia-description">
            <p>
              Join us every Tuesday night for an exciting trivia competition at Drake's! 
              Test your knowledge, compete with friends, and win amazing prizes.
            </p>
            
            <div className="trivia-details">
              <div className="trivia-detail">
                <h3>What to Expect</h3>
                <p>Multiple rounds of challenging questions across various categories including sports, 
                pop culture, history, science, and more!</p>
              </div>
              
              <div className="trivia-detail">
                <h3>Prizes</h3>
                <p>Win gift cards, Drake's merchandise, and bragging rights as the Trivia Champion!</p>
              </div>
              
              <div className="trivia-detail">
                <h3>Team Size</h3>
                <p>Form teams of up to 6 people. Don't have a team? Come anyway and we'll help you find one!</p>
              </div>
              
              <div className="trivia-detail">
                <h3>Reservations</h3>
                <p>Spots fill up quickly! Call ahead to reserve a table for your team.</p>
              </div>
            </div>
            
            <div className="trivia-buttons">
              <Link to="/reservations" className="trivia-cta-button">Reserve Your Spot</Link>
              <a 
                href="https://dangit.media/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="trivia-details-button"
              >
                More Details About Trivia Nights
              </a>
            </div>
          </div>
        </div>
        
        <div className="trivia-video-container">
          <video 
            ref={videoRef}
            className="trivia-video"
            src={triviaVideo}
            controls
            playsInline
          />
        </div>
      </div>
    </div>
  );
};

export default Trivia; 